export const OPEN_BOOKING = 'OPEN_BOOKING';
export const OPEN_FORM = 'OPEN_FORM';
export const SHOW_MORE_FORM = 'SHOW_MORE_FORM';
export const SHOW_VERIFICATION = 'SHOW_VERIFICATION';
export const SHOW_RENT = 'SHOW_RENT';
export const SHOW_CONFIRMATION = 'SHOW_CONFIRMATION';
export const SHOW_TERM = 'SHOW_TERM';
